import React from 'react'

export default class OnboardingTip extends React.Component {
  render() {
    const { text } = this.props

    return (
      <div className="onboarding-tip">
        <img src={require('../images/icon_onboarding_tip.png')} alt="tip" />
        {text}
      </div>
    )
  }
}
